import isAlertVisible from '../components/alert/utils/isAlertVisible';
import {useSelector} from 'react-redux';
import {selectAlertsLoading, selectAnnouncements} from '../selectors';
import {Alerts} from '../reducers/alerts.reducer';

const useGetAnnouncements = () => {
    const alertsLoading = useSelector(selectAlertsLoading);
    const announcements = useSelector(selectAnnouncements);
    const isLoading = alertsLoading;
    return {
        isLoading,
        announcements: (announcements || []).filter(announcement =>
            isAlertVisible(`${Alerts.ANNOUNCEMENT}-${announcement.key}`)
        )
    };
};

export default useGetAnnouncements;
